import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Button, Card, CardContent, Snackbar } from '@material-ui/core';
import { Typography } from '@mui/material';
import TextField from '@material-ui/core/TextField';
import MuiAlert from '@material-ui/lab/Alert';
import Loader from 'react-loader-spinner';
import { usePromiseTracker, trackPromise } from 'react-promise-tracker';
import { styled } from "@mui/material/styles";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  card: {
    height: '100%',
    display: 'flex',
    backgroundColor: '#f5f9fc',
    flexDirection: 'column',
    border: '2px solid #e6f8fb',
    borderRadius: '8px',
  },
  cardContent: {
    flexGrow: 1,
    padding: "24px",
  },
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '30ch',
    },
  },
  buttonStyle: {
    width: '30ch'
  },
}));

const WhiteTextTypography = withStyles({
  root: {
    color: "#3a3b3b"
  }
})(Typography);

// Loading Indicator Component
const LoadingIndicator = () => {
  const { promiseInProgress } = usePromiseTracker();
  return (
    promiseInProgress &&
    <div
      style={{
        width: "100%",
        height: "100",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
      >
      <Loader type="ThreeDots" color="#a61930" height="30" width="30" />
    </div>
  );
};

// Email Validation Function
function validateEmail(email) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export default function ContactForm({ headerText }) {
  const classes = useStyles();
  const [name, setName] = useState('');
  // ADD NEW STATE FOR EMAIL
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState("success");
  const [notificationMessage, setNotificationMessage] = useState("Form submitted! Our team will be in touch");

  const vertical = 'top';
  const horizontal = 'center';

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  // HANDLER FOR NAME
  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  // HANDLER FOR PHONE
  const handlePhoneChange = (event) => {
    setPhone(event.target.value);
  };

  // HANDLER FOR EMAIL
  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    // UPDATE REQUIRED FIELD CHECK
    if ((name === '') || (email === '') || (phone === '')) {
      setOpen(true);
      setSeverity('error');
      setNotificationMessage('All fields (Name, Email, Phone) are required');
      return;
    }

    // UPDATE EMAIL VALIDATION
    const isEmailValid = validateEmail(email);
    if (!isEmailValid) {
      setOpen(true);
      setSeverity('error');
      setNotificationMessage('Enter a valid email address');
      return;
    }

    // UPDATE API PAYLOAD
    let userSearchQuery = {
      customer_name: name, // Sending the name now
      customer_email: email, // Sending the correct email state
      contact: phone,
      siteID: 'benevolence'
    };

    const fetchSendDetails = fetch('https://comfycraft.co.uk/api/contact-form/', {
      method: 'POST',
      body: JSON.stringify(userSearchQuery),
      headers: {'Content-Type':'application/json'}
    });

    trackPromise(
      fetchSendDetails.then(response => {
        if (response.status === 200) {
          // Clear all three fields on success
          setName('');
          setEmail('');
          setPhone('');
          setOpen(true);
          setSeverity('success');
          setNotificationMessage('Form submitted! Our team will be in touch');
        } else {
           setOpen(true);
           setSeverity('error');
           setNotificationMessage('An error occurred during submission.');
        }
        return response;
      })
      .catch(error => {
          setOpen(true);
          setSeverity('error');
          setNotificationMessage('Network error. Please try again.');
          console.error("Submission error:", error);
      })
    );
  };

  return (
    <React.Fragment>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical, horizontal }}
        key={vertical + horizontal}
      >
        <Alert onClose={handleClose} severity={severity}>
          {notificationMessage}
        </Alert>
      </Snackbar>

      <Card className={classes.card}  elevation={0}>
        <CardContent className={classes.cardContent}>
          <div style={{textAlign: 'center'}}>
            <WhiteTextTypography
              component="h6"
              variant="h6"
              align="center"
              style={{fontWeight: 'bold', marginTop: '8px', marginBottom: '16px'}}>
              {headerText}
            </WhiteTextTypography>
          </div>
          <form onSubmit={handleSubmit} className={classes.root} noValidate autoComplete="off">
            <div style={{textAlign: 'center'}}>
              {/* 1. Name Field */}
              <TextField
                id="outlined-name"
                label="Name" // Label changed to Name
                value={name}
                onChange={handleNameChange} // Using the name handler
                variant="outlined"
                style={{paddingTop: '15px'}}
              />
              {/* 2. Email Field (New) */}
              <TextField
                id="outlined-email" // New ID
                label="Email" // Label is Email
                value={email} // Using the new email state
                onChange={handleEmailChange} // Using the new email handler
                variant="outlined"
                style={{paddingTop: '15px'}}
              />
              {/* 3. Phone Field */}
              <TextField
                id="outlined-phone"
                label="Phone"
                value={phone}
                onChange={handlePhoneChange}
                variant="outlined"
                style={{paddingTop: '15px'}}
              />
              <Button size='large'
                      disableElevation
                      className={classes.buttonStyle}
                      style={{marginTop: '25px', color: 'white'}}
                      type='submit' variant="contained" color="secondary">
                    Submit
              </Button>
              <LoadingIndicator/>
            </div>
          </form>
        </CardContent>
      </Card>
    </React.Fragment>
  );
}